import { Navigate } from "react-router-dom";
import TokenService from "../utils/TokenService";
import { useLocation } from "react-router-dom";

/** True only if path is /account/admin or /account/admin/... with ASCII "account" and "admin" (blocks homoglyphs cyber attacks). */
function isAccountAdminPath(pathname) {
    const segments = pathname.split("/").filter(Boolean);
    if (segments.length < 2) return false;
    const first = segments[0].toLowerCase();
    const second = segments[1].toLowerCase();
    if (first.length !== 7 || second.length !== 5) return false;
    const asciiLower = (s) => [...s].every((c) => (c.charCodeAt(0) >= 0x61 && c.charCodeAt(0) <= 0x7a));
    return asciiLower(first) && first === "account" && asciiLower(second) && second === "admin";
}

const PrivateRoute = ({ children }) => {
    const location = useLocation();

    if (!TokenService.isLoggedIn()) {
        if (!TokenService.isAuthenticated()) {
            // They are not authenticated at all, so set the redirect of what they were attempting to access after they login
            TokenService.setRedirectOnLogin(window.location.href);
            return <Navigate to="/" />;
        }
        if (TokenService.isPendingEmailVerification()) {
            // They are authenticated but need to verify their email
            return <Navigate to="/verify-email" />;
        }
        if (TokenService.isPending2fa()) {
            // They are authenticated but need to verify their 2FA
            return <Navigate to="/verify-2fa" />;
        }
        if (TokenService.is2faSetupRequired()) {
            // They are authenticated but need to setup their 2FA
            return <Navigate to="/setup-2fa" />;
        }
    }
    else {
        if (isAccountAdminPath(location.pathname)) {
            if (!TokenService.isWallistAdmin()) {
                return <Navigate to="/account/select-provider" />;
            }
        }
    }

    return children;
};

export default PrivateRoute;
